import script from "./site-device-table.vue?vue&type=script&lang=ts&setup=true"
export * from "./site-device-table.vue?vue&type=script&lang=ts&setup=true"

import "./site-device-table.vue?vue&type=style&index=0&id=91201442&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91201442"]])

export default __exports__